// Import necessary action types, HttpService, and Post function
import {
  POLL_VOTE_FETCH_DATA_SUCCESS,
  POLL_VOTE_HAVE_ERROR,
  POLL_VOTE_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Post } from "../../services/api.service";

// Action creator function to handle different types of post actions
export function PollVoteAction(action, payload) {
  switch (action) {
    case POLL_VOTE_HAVE_ERROR:
      // Return action object indicating error
      return {
        type: action,
        hasError: payload,
      };

    case POLL_VOTE_ARE_LOADING:
      // Return action object indicating loading state and resetting Post data to null
      return {
        type: action,
        isLoading: payload,
        Post: null,
      };

    case POLL_VOTE_FETCH_DATA_SUCCESS:
      // Return action object containing fetched post data
      return {
        type: action,
        Post: payload,
      };

    default:
      return;
  }
}

// Async action creator function to submit a poll vote
export function PollVoteFetchData(poll_id, selected_option) {
  return (dispatch) => {
    // Dispatch action to indicate data loading
    dispatch(PollVoteAction(POLL_VOTE_ARE_LOADING, true));

    // Make a POST request to submit the vote
    return Post(HttpService.PollVote, { 
      poll_id: poll_id,
      selected_option: selected_option 
    })
      .then((result) => {
        // Dispatch success action with fetched result
        dispatch(PollVoteAction(POLL_VOTE_FETCH_DATA_SUCCESS, result.data));
        // Resolve the promise with the result
        return result;
      })
      .catch((error) => {
        // Dispatch error action if request fails and reject the promise
        dispatch(PollVoteAction(POLL_VOTE_HAVE_ERROR, true));
        return Promise.reject(error);
      });
  };
}
